import { NavLink, Navigate, Route, Routes } from "react-router-dom";
import { TipEntryView } from "./views/TipEntryView";
import { SquareTipShareView } from "./views/SquareTipShareView";
import { EmployeesView } from "./views/EmployeesView";
import { PayPeriodsView } from "./views/PayPeriodsView";
import { TipsReportsView } from "./views/TipsReportsView";
import { TipsSettingsView } from "./views/TipsSettingsView";

const TABS = [
  { to: "",              label: "Bartender Entry",   end: true  },
  { to: "square-share",  label: "Square Tip Share",  end: false },
  { to: "employees",     label: "Employees",         end: false },
  { to: "periods",       label: "Pay Periods",       end: false },
  { to: "reports",       label: "All Reports",       end: false },
  { to: "settings",      label: "Settings",          end: false },
] as const;

export function TipsModule() {
  return (
    <div className="flex h-full flex-col">
      <header className="border-b border-tribal-border bg-tribal-surface px-4 pt-4 sm:px-6">
        <h1 className="text-lg font-semibold tracking-tight">Tips</h1>
        <nav className="mt-3 flex gap-1 overflow-x-auto" aria-label="Tips tabs">
          {TABS.map(({ to, label, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `whitespace-nowrap border-b-2 px-3 pb-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "border-tribal-red text-white"
                    : "border-transparent text-tribal-muted hover:border-white/20 hover:text-white"
                }`
              }
            >
              {label}
            </NavLink>
          ))}
        </nav>
      </header>

      <div className="min-h-0 flex-1 overflow-y-auto">
        <Routes>
          <Route index element={<TipEntryView />} />
          <Route path="square-share" element={<SquareTipShareView />} />
          <Route path="employees" element={<EmployeesView />} />
          <Route path="periods" element={<PayPeriodsView />} />
          <Route path="reports" element={<TipsReportsView />} />
          <Route path="coach-reports" element={<Navigate to="../reports" replace />} />
          <Route path="settings" element={<TipsSettingsView />} />
          <Route path="*" element={<Navigate to="" replace />} />
        </Routes>
      </div>
    </div>
  );
}
